module.exports = __webpack_public_path__ + "static/media/linkedin.44d52b35.svg";